export const truncateText = (text, maxLength) => {
    if (!text)
        return '';
    const stringText = text.toString();
    if (stringText.length <= maxLength)
        return stringText;
    return stringText.substring(0, maxLength) + '...';
};
